module.exports = __webpack_public_path__ + "img/Skinner.f094e4b8.jpeg";